<div class="mi-applicant-details container" id="mi-applicant-details" tabindex="-1" miFocusOnTab>

  <div class="row justify-content-center">
    <div class=" col-12 mi-panel-wrraper standart">
      <div class="mc-my-3">
        <h2 class="mi-header">{{tabsText.applicantDetails}}</h2>
      </div>
      <div class="mi-white-panel with-shadow">
        <div class="mi-back ">
          <mc-button [label]="genericText?.back" [ariaLabel]="genericText?.back" [icon]="'pi pi-fw pi-chevron-right'"
            class="mi-button-with-icon-primary" id="mi-applicant-details-back" (click)="back()"
            (keyup.enter)="back()"></mc-button>
        </div>

        <div>

          <span class="d-none d-sm-block mc-mt-1">
            {{validationText?.remark}}
          </span>
          <div class="mc-border-bottom d-none d-sm-block mc-mt-3"></div>
          <div>
            <mi-applicant-details-fields [applicant]="applicant"></mi-applicant-details-fields>
          </div>
        </div>

      </div>
      <div class=" row justify-content-center    justify-content-md-start">
        <div class="col-md-3 col-12 blue-button mi-next">
          <mc-button [label]="genericText?.next + ' >'" [ariaLabel]="genericText?.next" (click)="next()"
            [id]="'mi-applicant-details-next'">

          </mc-button>
        </div>
      </div>
    </div>
  </div>



</div>